import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Caută după ID, Nume sau Companie',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Stare conexiune',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Conectat',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Neconectat',
      },
    },
  },
  columns: {
    name: 'Nume',
    company: 'Companie',
    connected: 'Conectat',
    action: 'Acțiune',
    details: 'Detalii',
    address: 'Adresă',
    status: 'Stare',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Nespecificat',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Activ',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Pauzat',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Necunoscut',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Eliminat',
  },
};
